import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { FaArrowLeft } from "react-icons/fa";
import { FaLanguage } from "react-icons/fa";
import { StepsContainerStyled } from "../../../../styled/Resume";
import PublicationCard from "../../Tools/PublicationCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const PublicationInfo = (props) => {
    const {
        step,
        setStep,
        setStepData,
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,
        pubForwardOrBackward
    } = props;

    const [disableFields, setDisableFields] = useState(false);
    const { themeName } = useTheme();

    useEffect(() => {
        setStepData((prev) => ({
            ...prev,
            publicationsInfo: publications
        }));
    }, [publications, setStepData]);

    useEffect(() => {
        if (!publications || publications.length === 0) {
            setDisableFields(false); 
            return;
        }

        const hasIncomplete = publications.some(
            (pub) =>
                (pub.title?.trim() === "" && (pub.source?.trim() !== "" || pub.date?.trim() !== "")) ||
                (pub.source?.trim() === "" && (pub.title?.trim() !== "" || pub.date?.trim() !== "")) ||
                (pub.date?.trim() === "" && (pub.title?.trim() !== "" || pub.source?.trim() !== ""))
        );

        setDisableFields(hasIncomplete); 
    }, [publications]);

    const handleClickForward = (e) => {
        if (e) e.preventDefault();
        pubForwardOrBackward("forward");
        if (!disableFields) {
            setStep(step + 1);
        }
    };

    const handleClickBackward = (e) => {
        if (e) e.preventDefault();
        pubForwardOrBackward("backward");
        setStep(step - 1);
    };

    return (
        <StepsContainerStyled theme={themeName}>
            <h2>
                Publications & Projects <span>(Optional)</span>
            </h2>
            <PublicationCard
                publications={publications}
                handlePubChange={handlePubChange}
                handleDeletePublication={handleDeletePublication}
                handleAddPublication={handleAddPublication}
            />
            <div className={step > 1 ? "btnS" : "btn"}>
                <Button
                    justifycontent="start"
                    secondaryLight
                    width="100%"
                    clickHandle={handleClickBackward}
                >
                    <FaArrowLeft />
                    Previous
                </Button>
                    <div className="nextBtnWrap">
                        <Button
                            justifycontent="flex-end"
                            primary
                            width="100%"
                            clickHandle={handleClickForward}
                            disabled={disableFields}
                        >
                            Language
                            <FaLanguage />
                        </Button>
                    </div>
            </div>
        </StepsContainerStyled>
    );
};

export default PublicationInfo;
